export class AxProgressBar {
    private Target: JQuery<HTMLElement>;
    private Options: Options;

    private working = false;

    Init(options: Options) {
        this.Options = options;
        this.Target = $(this.Options.target);

        if (this.Target.length > 0) {
            this.Target.addClass('ax-progressbar').addClass('ax-progressbar--header');

            for (let step of this.Options.steps) {
                let outer = document.createElement('div');
                if (step.type != 'divider') {
                    outer.classList.add('ax-progressbar-step');

                    if (step.type != 'inactive') {
                        outer.classList.add('ax-progressbar-step--' + step.type);
                    }

                    let icon = document.createElement('i');
                    outer.appendChild(icon);

                    let label = document.createElement('div');
                    label.innerHTML = step.label;
                    outer.appendChild(label);
                } else {
                    outer.classList.add('ax-progressbar--header-divider');
                }
                this.Target.append(outer);
                step.elem = outer;
            }

            this.checkProgressBarSize();

            $(window).on("resize", () => {
                this.checkProgressBarSize();
            });
        }
    }

    checkProgressBarSize() {
        let isOverflow: boolean = true;

        if (!this.working) {
            this.working = true;
            const currentActiveIndex = this.Options.steps.findIndex(x => x.type === 'active');
            ;
            while (isOverflow) { isOverflow = this.checkOverflow(currentActiveIndex) }

            if (!isOverflow) {
                this.checkNoOverflow(currentActiveIndex);
            }
            this.working = false;
        }
    }

    checkNoOverflow(currentActiveIndex: number) {
        const firstInactive = this.Options.steps.findIndex(x => x.type === 'hidden');

        if (this.isOverflown(this.Target[0]) || firstInactive === -1) {
            return;
        }

        const startIndexDif = firstInactive < currentActiveIndex ? (currentActiveIndex - this.Options.steps.findIndex(x => x.type !== 'hidden')) + 1 : -1;

        const firstInactiveEnd = this.Options.steps.slice(currentActiveIndex).findIndex(x => x.type === 'hidden');
        const endIndexDif = firstInactiveEnd !== -1 ? firstInactiveEnd : startIndexDif + 1;

        let stepToShow: Step;
        if (startIndexDif >= 0 && startIndexDif < endIndexDif) {
            stepToShow = this.Options.steps[currentActiveIndex - startIndexDif];
        } else {
            stepToShow = this.Options.steps[currentActiveIndex + endIndexDif];
        }
        stepToShow.type = stepToShow.orgType;
        stepToShow.elem.style.visibility = 'hidden';
        stepToShow.elem.classList.remove('ax-progressbar-step--hidden');

        this.checkOverflow(currentActiveIndex);
        stepToShow.elem.style.visibility = 'visible';
    }

    checkOverflow(currentActiveIndex: number): boolean {
        if (!this.isOverflown(this.Target[0])) {
            return false;
        }
        const reverseSteps = this.Options.steps.slice().reverse();
        const startIndexDif = currentActiveIndex - this.Options.steps.findIndex(x => x.type !== 'hidden');
        const endIndexDif = (currentActiveIndex - (reverseSteps.length - reverseSteps.findIndex(x => x.type !== 'hidden'))) * -1 - 1;

        let stepToRemove: Step;
        if (startIndexDif >= endIndexDif) {
            stepToRemove = this.Options.steps[currentActiveIndex - startIndexDif];
        } else {
            stepToRemove = this.Options.steps[currentActiveIndex + endIndexDif];
        }

        stepToRemove.orgType = stepToRemove.type;
        stepToRemove.type = 'hidden';
        stepToRemove.elem.classList.add('ax-progressbar-step--hidden');

        return true;
    }

    isOverflown(element: HTMLElement) {
        return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    }

    destroy() {
        this.Target.html('');
    }
}

export interface Options {
    target: string;
    steps: Step[];
}

export interface Step {
    label?: string;
    type: 'inactive' | 'active' | 'done' | 'divider' | 'hidden';
    orgType?: 'inactive' | 'active' | 'done' | 'divider' | 'hidden';
    elem?: HTMLDivElement;
    alias?: string;
}